// Archive purge + bulk restore : POST /api/content/archive/{purge,restore-bulk}.
//
// Permanent purge is gated server-side on feature:deleted-pages:purge (ordinary editors lack it);
// bulk restore on feature:deleted-pages:write. Both go through the shared `axios` instance so the
// Auth0AxiosBridge interceptor attaches the admin Bearer token on deployed instances.
//
// HAND-WRITTEN client : lives beside its consumer because `src/API/` is regenerated wholesale.
import axios from "axios";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export interface ArchivePurgeResult {
	requested: number;
	purged: string[];
	skipped: string[];
	purgedCount: number;
}

export interface ArchiveRestoreItemOutcome {
	id: string;
	status: string; // "restored" | "error"
	message?: string | null;
}

export interface ArchiveRestoreBulkResult {
	outcomes: ArchiveRestoreItemOutcome[];
	restoredCount: number;
	errorCount: number;
}

export async function purgeArchive(body: {
	ids?: string[];
	all?: boolean;
	olderThanDays?: number;
}): Promise<ArchivePurgeResult> {
	const r = await axios.post<ArchivePurgeResult>(
		`${apiBase}/api/content/archive/purge`,
		body,
		{ withCredentials: true }
	);
	return r.data;
}

export async function restoreArchiveBulk(body: {
	ids?: string[];
	all?: boolean;
}): Promise<ArchiveRestoreBulkResult> {
	const r = await axios.post<ArchiveRestoreBulkResult>(
		`${apiBase}/api/content/archive/restore-bulk`,
		body,
		{ withCredentials: true }
	);
	return r.data;
}
